import React from 'react'
import { LineItemFulfilmentAddress } from '../../LineItemFulfilmentAddress'
import { useLineItemFulfilmentFixSaleAddressesModel } from './useLineItemFulfilmentFixSaleAddressesModel'

export const LineItemFulfilmentFixSaleAddresses: React.FC = () => {
  const {
    fulfilmentDetail,
    incorrectAddressMessage,
    incorrectAddressDescription,
    shouldShowFulfilmentAddress,
  } = useLineItemFulfilmentFixSaleAddressesModel()

  return (
    <div className="uc-base font-general">
      <div className="flex flex-col gap-6">
        {incorrectAddressMessage && (
          <>
            <h3 className="typography-body-sm-emphasized text-fg-neutral-default">
              {incorrectAddressMessage}
            </h3>

            <p className="typography-body-sm text-fg-neutral-default">
              {incorrectAddressDescription}
            </p>
          </>
        )}
        {shouldShowFulfilmentAddress && (
          <div className="vd-mb8">
            <LineItemFulfilmentAddress
              fulfillmentDetail={fulfilmentDetail}
              isModalOpeningOnError={true}
            />
          </div>
        )}
      </div>
    </div>
  )
}
